import { FileType } from '@office-start/document-types';
export function fetchFileTypes(fileType, pdfEnabled, upcomingMeetingEnabled, visioEnabled) {
    var _a;
    return (
    // TODO: this is a temporary workaround for fetching stream recommended. Should be removed after the value is from config
    (_a = (fileType &&
        (fileType === FileType.Stream
            ? [FileType.Video, FileType.PlayList]
            : [fileType]))) !== null && _a !== void 0 ? _a : getFileTypes(pdfEnabled, upcomingMeetingEnabled, visioEnabled));
}
export function getFileTypes(pdfEnabled, upcomingMeetingEnabled, visioEnabled) {
    var fileTypes = [
        FileType.Word,
        FileType.Excel,
        FileType.PowerPoint,
        FileType.OneNote,
    ];
    if (pdfEnabled) {
        fileTypes.push(FileType.Pdf);
    }
    if (visioEnabled) {
        fileTypes.push(FileType.Visio);
    }
    if (upcomingMeetingEnabled) {
        fileTypes.push(FileType.UpcomingMeeting);
    }
    return fileTypes;
}
//# sourceMappingURL=getFileTypes.js.map